<template>
	<div class="width-100 display-flex flex-row flex-justify-space-between flex-align-center">
		<div class="item-container display-flex flex-column flex-justify-center width-100">
			<div class="title-container display-flex flex-row width-100">
				<ConnectionNameEditableTextField ref="connection_name" :text="item.connection_name" :key="item.id" :id="item.id" />
			</div>
			<div class="description-container display-flex flex-row flex-align-center">
				<SIcon class="icon mr-1" :name="projectIconIndicatorName" width="10" />
				{{ projectTitle }}
			</div>
		</div>
		<AppDropdownMenu v-if="!item.isLocked" left bottom absolute min-width="265" :nudge-bottom="10" :items="optionsMenuItems">
			<template #activator="{}">
				<v-btn icon x-small rounded width="20" height="20" class="field-action-button">
					<SIcon class="menu-button" name="menu-button" width="20" />
				</v-btn>
			</template>
		</AppDropdownMenu>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import ConnectionNameEditableTextField from '@/components/common/ProfileSelector/ConnectionNameEditableTextField';
import { teamMembers } from '@/store/modules/account/getters';
import { getService } from '@/store/modules/apps/getters';
import { projectsList } from '@/store/modules/projects/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters.js';
import { mapGettersShorthand } from '@/store/utils/mappers';
import ProjectService from '@/utils/projects-service';
export default {
	name: 'EmbeddedProfileSelectionItem',
	props: {
		item: { type: Object },
	},
	components: {
		ConnectionNameEditableTextField,
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ projectsList, teamMembers, getService, selectedProjectId }),
		selectedServiceId() {
			return this.item.service;
		},
		selectedApp() {
			return this.getService(this.selectedServiceId);
		},
		serviceSlug() {
			return this.selectedApp?.service_slug;
		},
		lockedConnectionOwnerName() {
			if (!this.connectionProject) {
				return this.teamMembers.find((x) => x.user_id === this.item.user)?.name || '';
			}
			return null;
		},
		userPersonalProject() {
			return this.projectsList.find((proj) => this.isPersonalProject(proj));
		},
		connectionProject() {
			const relatedProjectId = this.item?.access?.related_entity_id;
			if (relatedProjectId) {
				return this.projectsList.find((proj) => proj.id === relatedProjectId);
			} else {
				if (this.isCurrentUserOwnerOfPrivateLockedConnection) {
					return this.userPersonalProject;
				}
			}
			return null;
		},
		isCurrentUserOwnerOfPrivateLockedConnection() {
			return !this.item.user || this.item.user === this.userPersonalProject.owner;
		},
		projectTitle() {
			return (
				this.connectionProject?.title ||
				(this.lockedConnectionOwnerName ? `Personal connection by ${this.lockedConnectionOwnerName} - locked` : '(space was deleted)')
			);
		},
		projectIconIndicatorName() {
			return `${!this.connectionProject || this.isPersonalProject(this.connectionProject) ? 'personal' : 'collaborative'}-space`;
		},
		connectionType() {
			return this.item.isLocked ? 'Locked' : this.item.isProject ? 'Space' : 'Private';
		},
		optionsMenuItems() {
			return [
				{ text: `Rename`, onClick: this.toggleEditName },
				{ text: `Manage`, appendIcon: 'open-in-a-new-tab', appendIconWidth: 9, onClick: this.manageConnection },
			];
		},
	},
	methods: {
		isPersonalProject(project) {
			return ProjectService.isMyPersonalProject(project, this.user);
		},
		manageConnection() {
			window.open(`/space/${this.selectedProjectId}/connections`, '_blank');
		},
		toggleEditName() {
			this.$refs.connection_name.setIsEditing(true);
		},
	},
};
</script>
<style lang="scss" scoped>
.menu-button {
	margin-top: 3px;
	margin-right: 2px;
}
.item-container {
	height: 34px;
	background: var(--bg-color) !important;

	&:hover {
		background: var(--selection-hover-background);
	}

	.title-container {
		background: var(--bg-color);
	}

	.description-container {
		font-size: 12px;
		color: #939baa;
	}
	.lock-icon {
		font-size: 14px;
	}
}
</style>
